import { Job } from 'models/job';
import {Agent, request} from './base';

export class JobsAgent extends Agent<Job> {
    constructor() {
        super(Job, '/jobs');
    }

    sync = async () => {
        await request.post('/jobs/sync', {});
    };
}
